"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromIni = void 0;
const credential_provider_ini_1 = require("@aws-sdk/credential-provider-ini");
const fromIni = (init = {}) => (0, credential_provider_ini_1.fromIni)({
    ...init,
});
exports.fromIni = fromIni;
